import styled from "styled-components";

export const StyledRange = styled.div`
    width: 200px;
    position: relative;
    margin-top: -8px;
    height: 56px;
`;

export const Background = styled.div`
    position: absolute;
    width: 100%;
    height: 6px;
    top: 15px;
    left: 0;
    background-color: ${p => p.theme.c.disabled};
`;

export const ValueBar = styled.div`
    background-color: ${p => p.theme.c.active};
    height: 6px;
    top: 15px;
    left: 0;
    position: absolute;
`;

const $dimension = 24;

export const Slide = styled.div`
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
`;

export const SlideButton = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: ${$dimension}px;
    height: ${$dimension}px;
    margin-left: ${-$dimension / 2}px;
    margin-top: ${-$dimension / 2}px;
    border-radius: ${$dimension / 2}px;
    background-color: ${p => p.theme.c.active};
    cursor: pointer;
`;

export const SlideValue = styled.div`
    display: inline-block;
    width: ${$dimension}px;
    text-align: center;
    margin-left: ${-$dimension / 2}px;
    margin-top: 12px;
    position: absolute;
    top: 0;
    left: 0;
    transition: 50ms;
    font-weight: 300;
    user-select: none;
`;
